<template>
  <div class="flex">
    <div class="left">
      <el-tree
			default-expand-all
        :data="treeData"
        show-checkbox
        node-key="id"
        ref="tree"
        @check="selectChange"
        :default-expanded-keys="[2, 3]"
        :default-checked-keys="resourceCheckedKey"
        :props="defaultProps"
      >
      </el-tree>
    </div>
    <div class="right">
      <Table
        ref="table"
        :perDatas="perDatas"
        :outPerDatas="outPerDatas"
        :state="state"
        :cusId="cusId"
        :dialogheaderVisible="dialogheaderVisible"
        @refushSelectPerson="refushSelectPerson"
        v-on:personDatas="personClick">
      </Table>
    </div>
  </div>

</template>

<script>
  import Table from "@/views/wage/attachmentManage/table.vue";
  import {queryOrgTreeSelect} from "@/api/wage/attachmentManage";
  import Vue from 'vue'

  export default {
    name: "selectPerson",
    props:{
      perDatas: {
        type: Array,
        default: () => (
          []
        )
      },
      cusId:{
        type:String,
        default:"",
      },
      outPerDatas: {
        type: Array,
        default: () => (
          []
        )
      },
      title: {
        type: String,
        default: () => (
          ''
        )
      },
      state: {
        type: String,
        default: '',
      },
      dialogheaderVisible: {
        type: Boolean,
        default: false,
      },

    },
    created(){
      this._queryOrgTreeSelect();

    },
    components:{Table},
    data() {
      return {
        defaultProps: {
          children: 'children',
          label: 'orgName'
        },
        orgMaps:{},
        treeData:[],
        orgIds:[],
        resourceCheckedKey:[]
        // state:true,
      };
    },
    methods:{
      _queryOrgTreeSelect(){
        queryOrgTreeSelect().then((res) => {
          this.treeData = res.data;
          console.log("机构数组------",this.treeData);
          const arr = [];
          for(var i= 0;i < res.data.length;i++){
              arr.push(res.data[i].id)
          }
          console.log(this.$refs.tree);
          this.$refs.tree.setCheckedKeys(arr);
          // console.log('当前CodeItem分页对象为：'+JSON.stringify(this.list))
        });
      },
      // test:function(){
      //   setTimeout(function () {
      //       that.resourceCheckedKey.forEach((value)=>{
      //           //setChecked 子节点只选中一个需要用setChecked，（(key/data, checked, deep) 接收三个参数，
      //           // 1. 勾选节点的 key 或者 data 2. boolean 类型，节点是否选中 3. boolean 类型，是否设置子节点 ，默认为 false）如果全部选中setCheckedKeys
      //           that.$refs.tree.setChecked(value,true,false)
      //       });
      //   },500);
      //     return this.treeData;
      // },
      selectChange(){
        this.orgIds = this.$refs.tree.getCheckedKeys();
        console.log("选择机构ids------",this.orgIds);
        this.$refs.table._getListpage(this.orgIds);
      },
      personClick(e){
        console.log("选择的人员e==",e);
        this.$emit('personDatas',e);
      },
      refushSelectPerson(){
        console.log("refushSelectPerson~~~~~~~~~~~~~~~~");
        this.$emit("refushAttchment");
        this.$emit("performDialog");
      }

    }
  };
</script>

<style scoped>
  .flex{
    display: flex;
  }
  .flex>div{
    height: calc(90vh - 150px);

  }
  .flex>div:nth-of-type(1){
    width: 250px;
    border-right: 1px solid #ccc;
    padding-right: 20px;
    margin-right:20px;
    overflow: auto;
  }
  .flex>div:nth-of-type(2){
    width: calc(100% - 255px);
  }
</style>
